import { AGRNT_AUTH_CODE } from '@/pages/agent/js/enum'
import erpRouter from './erp.router'

import OrderKPI from '@/pages/agent/orderKPI.vue'
const agentRouterList = [
  {
    name: 'agent',
    path: '/agent',
    redirect: '/agent/index',
    component: () => import('../../pages/agent/layout'),
    children: [
      {
        name: 'agentApply',
        path: '/agent/apply',
        meta: { title: '代理员申请', topNavName: '代理员申请' },
        component: () =>
          import(
            /* webpackChunkName: "agentApply" */ '../../pages/agent/apply'
          ),
      },
      {
        name: 'agentResult',
        path: '/agent/result',
        meta: { title: '代理员申请', topNavName: '代理员申请' },
        component: () =>
          import(
            /* webpackChunkName: "agentResult" */ '../../pages/agent/result'
          ),
      },
      {
        name: 'agentIdentitySelect',
        path: '/agent/identity-select',
        meta: { title: '代理中心', topNavName: '代理中心' },
        component: () =>
          import(
            /* webpackChunkName: "agentIdentitySelect" */ '@/pages/agent/identity-select/index.vue'
          ),
      },
      {
        name: 'agentIndex',
        path: '/agent/index',
        meta: { title: '代理中心', topNavName: '代理中心' },
        component: () =>
          // import(/* webpackChunkName: "agentIndex" */ '../../pages/agent/index')
          import(
            /* webpackChunkName: "agentIndex" */ '@/pages/workbench/index.vue'
          ),
      },
      {
        name: 'customerManagement',
        path: '/agent/customerManagement',
        meta: {
          title: '客户管理',
          topNavName: '客户管理',
          roleCode: AGRNT_AUTH_CODE.CUSTOMER_MANAGEMENT,
          storePath: '/store/storeCustomerManagement',
          cacheKey: 'Agents',
        },
        component: () =>
          import(
            /* webpackChunkName: "agentIndex" */ '../../pages/agent/agents.vue'
          ),
      },
      {
        name: 'blockNameList',
        path: '/agent/blockNameList',
        meta: {
          title: '拉黑名单',
          topNavName: '拉黑名单',
        },
        component: () =>
          import(
            /* webpackChunkName: "agentIndex" */ '../../pages/agent/blockNameList.vue'
          ),
      },
      {
        name: 'agentDetail',
        path: '/agent/detail',
        meta: {
          title: '代理详情',
          topNavName: '代理详情',
          storePath: '/store/storeAgentDetail',
        },
        component: () =>
          import(
            /* webpackChunkName: "agentIndex" */ '../../pages/agent/detail'
          ),
      },
      {
        name: 'AgentEnvelopeData',
        path: '/agent/agentEnvelopeData',
        meta: { title: '答题有礼红包数据', topNavName: '答题有礼红包数据' },
        component: () =>
          import(
            /* webpackChunkName: "agentIndex" */ '../../pages/agent/agentEnvelopeData'
          ),
      },
      {
        name: 'WatchingRewardData',
        path: '/agent/watchingRewardData',
        meta: { title: '观看奖励红包数据', topNavName: '观看奖励红包数据' },
        component: () =>
          import(
            /* webpackChunkName: "agentIndex" */ '../../pages/agent/watchingRewardData'
          ),
      },
      {
        name: 'agentError',
        path: '/agent/error',
        meta: { title: '暂无权限', topNavName: '暂无权限' },
        component: () =>
          import(
            /* webpackChunkName: "agentError" */ '../../pages/agent/error'
          ),
      },
      {
        name: 'inviteSource',
        path: '/agent/inviteSource',
        meta: { title: '邀请来源', topNavName: '邀请来源' },
        component: () =>
          import(
            /* webpackChunkName: "inviteSource" */ '../../pages/agent/inviteSource'
          ),
      },
      {
        name: 'topicInviteSource',
        path: '/agent/topicInviteSource',
        meta: { title: '邀请来源', topNavName: '邀请来源' },
        component: () =>
          import(
            /* webpackChunkName: "topicInviteSource" */ '../../pages/agent/topicInviteSource'
          ),
      },
      {
        name: 'agentTopics',
        path: '/agent/topics',
        meta: {
          title: '代理中心',
          noAuthData: true,
          topNavName: '代理中心',
          storePath: '/store/storeAgentTopics',
        },
        component: () =>
          import(
            /* webpackChunkName: "agentTopics" */ '../../pages/agent/topics.vue'
          ),
      },
      {
        name: 'topicDetail',
        path: '/agent/topicDetail',
        meta: { title: '代理推广话题详情', topNavName: '代理推广话题详情' },
        component: () =>
          import(
            /* webpackChunkName: "topicDetail" */ '../../pages/agent/topicDetail.vue'
          ),
      },
      {
        name: 'healthUserDetail',
        path: '/agent/healthUserDetail',
        meta: {
          title: '观众详情',
          topNavName: '观众详情',
          storePath: '/store/healthUserDetail',
        },
        component: () =>
          import(
            /* webpackChunkName: "healthUserDetail" */ '../../pages/agent/healthUserDetail.vue'
          ),
      },
      {
        name: 'customerDetail',
        path: '/agent/customerDetail',
        meta: {
          title: '客户详情',
          topNavName: '客户详情',
          roleCode: AGRNT_AUTH_CODE.CUSTOMER_MANAGEMENT,
          storePath: '/store/storeCustomerDetail',
          cacheKey: 'Agents',
        },
        component: () =>
          import(
            /* webpackChunkName: "customerDetail" */ '../../pages/agent/customerDetail.vue'
          ),
      },
      {
        name: 'groupDetail',
        path: '/agent/groupDetail',
        meta: { title: '群详情', topNavName: '群详情' },
        component: () =>
          import(
            /* webpackChunkName: "groupDetail" */ '../../pages/agent/groupDetail.vue'
          ),
      },
      {
        name: 'sendAll',
        path: '/agent/sendAll',
        meta: { title: '企业微信群发通知', topNavName: '企业微信群发通知' },
        component: () =>
          import(
            /* webpackChunkName: "sendAll" */ '../../pages/agent/sendAll.vue'
          ),
      },
      {
        name: 'sendDetail',
        path: '/agent/sendDetail',
        meta: { title: '群发通知详情', topNavName: '群发通知详情' },
        component: () =>
          import(
            /* webpackChunkName: "sendDetail" */ '../../pages/agent/sendDetail.vue'
          ),
      },
      {
        name: 'createSend',
        path: '/agent/createSend',
        meta: { title: '创建群发', topNavName: '创建群发' },
        component: () =>
          import(
            /* webpackChunkName: "createSend" */ '../../pages/agent/createSend.vue'
          ),
      },
      {
        name: 'newInviteCard',
        path: '/agent/newInviteCard',
        meta: { title: '邀请卡生成', topNavName: '邀请卡生成' },
        component: () =>
          import(
            /* webpackChunkName: "newInviteCard" */ '../../pages/agent/newInviteCard.vue'
          ),
      },
      {
        name: 'errInfo',
        path: '/agent/errInfo',
        meta: { title: '错误信息', topNavName: '错误信息' },
        component: () =>
          import(
            /* webpackChunkName: "newInviteCard" */ '../../pages/agent/errInfo.vue'
          ),
      },
      {
        name: 'warmPrompt',
        path: '/agent/warmPrompt',
        meta: { title: '温馨提示', topNavName: '温馨提示' },
        component: () =>
          import(
            /* webpackChunkName: "newInviteCard" */ '../../pages/agent/warmPrompt.vue'
          ),
      },
      {
        name: 'DownloadCenter',
        path: '/agent/downloadCenter',
        meta: {
          title: '下载中心',
          topNavName: '下载中心',
          storePath: '/store/downloadCenter',
        },
        component: () =>
          import(
            /* webpackChunkName: "downloadCenter" */ '../../pages/agent/downloadCenter.vue'
          ),
      },
      {
        name: 'myAccount',
        path: '/agent/myAccount',
        meta: { title: '我的账户', topNavName: '我的账户' },
        component: () =>
          import(
            /* webpackChunkName: "newInviteCard" */ '../../pages/agent/myAccount.vue'
          ),
      },
      {
        name: 'rechargeRecord',
        path: '/agent/rechargeRecord',
        meta: { title: '充值记录', topNavName: '充值记录' },
        component: () =>
          import(
            /* webpackChunkName: "newInviteCard" */ '../../pages/agent/rechargeRecord.vue'
          ),
      },
      {
        name: 'consumeDetail',
        path: '/agent/consumeDetail',
        meta: { title: '消耗明细', topNavName: '消耗明细' },
        component: () =>
          import(
            /* webpackChunkName: "newInviteCard" */ '../../pages/agent/consumeDetail.vue'
          ),
      },
      {
        name: 'BusinessManage',
        path: '/agent/businessManage',
        meta: {
          title: '商机管理',
          topNavName: '商机管理',
          roleCode: AGRNT_AUTH_CODE.OPPORTUNITY_MANAGEMENT,
        },
        component: () =>
          import(
            /* webpackChunkName: "newInviteCard" */ '../../pages/agent/businessManage.vue'
          ),
      },
      {
        name: 'taskDetail',
        path: '/agent/taskDetail',
        meta: { title: '任务详情', topNavName: '任务详情' },
        component: () =>
          import(
            /* webpackChunkName: "taskDetail" */ '../../pages/agent/taskDetail.vue'
          ),
      },
      {
        name: 'student',
        path: '/agent/student',
        meta: { title: '观看学员', topNavName: '观看学员' },
        component: () =>
          import(
            /* webpackChunkName: "student" */ '../../pages/agent/student.vue'
          ),
      },
      {
        name: 'promotionAnalysis',
        path: '/agent/promotionAnalysis',
        meta: { title: '推广分析', topNavName: '推广分析' },
        component: () =>
          import(
            /* webpackChunkName: "promotionAnalysis" */ '../../pages/agent/promotionAnalysis.vue'
          ),
      },
      {
        name: 'column',
        path: '/agent/column',
        meta: { title: '加载中...' },
        component: () =>
          import(
            /* webpackChunkName: "column" */ '../../pages/agent/column.vue'
          ),
      },
      {
        name: 'period',
        path: '/agent/period',
        meta: { title: '加载中...', h5forbidden: true },
        component: () =>
          import(
            /* webpackChunkName: "period" */ '../../pages/agent/period.vue'
          ),
      },
      {
        name: 'MemberManage',
        path: '/agent/memberManage',
        meta: {
          title: '加载中...',
          topNavName: '会员管理',
          roleCode: AGRNT_AUTH_CODE.MEMBERS_VIEW,
          storePath: '/store/storeMemberManage',
        },
        component: () =>
          import(
            /* webpackChunkName: "memberManage" */ '../../pages/agent/memberManage.vue'
          ),
      },
      {
        name: 'orderKPI',
        path: '/agent/orderKPI',
        meta: {
          title: '订单统计',
          topNavName: '订单统计',
          roleCode: AGRNT_AUTH_CODE.ORDER_STATISTICS,
          storePath: '/store/orderKPI',
          cacheKey: 'OrderKPI',
        },
        component: OrderKPI,
      },
      {
        name: 'goodsStatistics',
        path: '/agent/goodsStatistics',
        meta: {
          title: '商品统计',
          topNavName: '商品统计',
          roleCode: AGRNT_AUTH_CODE.PRODUCT_STATISTICS,
        },
        component: () =>
          import(
            /* webpackChunkName: "goodsStatistics" */ '../../pages/agent/goodsStatistics.vue'
          ),
      },
      {
        name: 'CommodityStatisticsDetails',
        path: '/agent/commodityStatisticsDetails',
        meta: {
          title: '商品统计明细-门店核销',
          topNavName: '商品统计明细-门店核销',
        },
        component: () =>
          import(
            /* webpackChunkName: "goodsStatistics" */ '../../pages/agent/CommodityStatisticsDetails.vue'
          ),
      },
      {
        name: 'agentRefund',
        path: 'agent/refund',
        meta: {
          title: '售后处理',
          topNavName: '售后处理',
          roleCode: AGRNT_AUTH_CODE.AFTER_SALES_PROCESSING,
        },
        component: () =>
          import(
            /* webpackChunkName: "refundCheck" */ '../../pages/agent/shopRefund.vue'
          ),
      },
      {
        name: 'couponStatistics',
        path: '/agent/couponStatistics',
        meta: {
          title: '优惠券统计',
          topNavName: '优惠券统计',
          roleCode: AGRNT_AUTH_CODE.COUPON_STATISTICS,
        },
        component: () =>
          import(
            /* webpackChunkName: "couponStatistics" */ '../../pages/agent/couponStatistics.vue'
          ),
      },
      {
        name: 'deliveryNote',
        path: '/agent/deliveryNote',
        meta: {
          title: '在途配送',
          topNavName: '在途配送',
          roleCode: AGRNT_AUTH_CODE.IN_TRANSIT_DELIVERY,
        },
        component: () =>
          import(
            /* webpackChunkName: "couponStatistics" */ '../../pages/agent/deliveryNote.vue'
          ),
      },
      {
        name: 'deliveryProcureNote',
        path: '/agent/deliveryProcureNote',
        meta: {
          title: '在途配送',
          topNavName: '在途配送',
          roleCode: AGRNT_AUTH_CODE.IN_TRANSIT_DELIVERY,
          storePath: '/store/deliveryNoteLogistics',
        },
        component: () =>
          import(
            /* webpackChunkName: "deliveryProcureNote" */ '../../pages/agent/deliveryProcureNote.vue'
          ),
      },
      {
        name: 'tradeComplaint',
        path: '/agent/tradeComplaint',
        meta: {
          title: '交易投诉',
          topNavName: '交易投诉',
          storePath: '/store/tradeComplaint',
        },
        component: () =>
          import(
            /* webpackChunkName: "tradeComplaint" */ '@/pages/agent/tradeComplaint.vue'
          ),
      },
      {
        name: 'agentVerfiyRecord',
        path: '/agent/verify/verifyRecord',
        meta: {
          title: '核销记录',
          topNavName: '核销记录',
          roleCode: AGRNT_AUTH_CODE.VERIFICATION_RECORD,
          storePath: '/store/verify/verifyRecord',
        },
        component: () =>
          import(
            /* webpackChunkName: "verification" */ '@/pages/agent/verify/record.vue'
          ),
      },
      // 发货单详情-商品列表
      {
        name: 'deliveryNoteProductList',
        path: '/agent/deliveryNoteProductList',
        meta: {
          title: '在途配送',
          topNavName: '在途配送',
          storePath: '/store/deliveryNoteProductList',
        },
        component: () =>
          import(
            /* webpackChunkName: "couponStatistics" */ '../../pages/agent/deliveryNoteProductList.vue'
          ),
      },
      // 发货单-物流轨迹
      {
        name: 'deliveryNoteLogistics',
        path: '/agent/deliveryNoteLogistics',
        meta: { title: '在途配送', topNavName: '在途配送' },
        component: () =>
          import(
            /* webpackChunkName: "couponStatistics" */ '../../pages/agent/deliveryNoteLogistics.vue'
          ),
      },
      {
        name: 'couponDetail',
        path: '/agent/couponDetail',
        meta: {
          title: '优惠券详情',
          topNavName: '优惠券详情',
          storePath: '/store/couponDetail',
        },
        component: () =>
          import(
            /* webpackChunkName: "couponDetail" */ '../../pages/agent/couponDetail.vue'
          ),
      },
      {
        name: 'operationStatement',
        path: '/agent/operationStatement',
        meta: {
          title: '经营报表',
          topNavName: '经营报表',
          roleCode: AGRNT_AUTH_CODE.BUSINESS_REPORT,
          storePath: '/store/operationStatement',
        },
        component: () =>
          import(
            /* webpackChunkName: "operationStatement" */ '../../pages/agent/operationStatement.vue'
          ),
      },
      {
        name: 'agentIncomePage',
        path: '/agent/incomepage',
        meta: {
          title: '收益明细-自动结算',
          topNavName: '收益明细-自动结算',
          roleCode: AGRNT_AUTH_CODE.COMMISSION_INCOME,
          storePath: '/store/commission/incomepage',
        },
        component: () => import('@/pages/commission/IncomePage.vue'),
      },
      {
        name: 'agentIncomePageManual',
        path: '/agent/incomepagemanual',
        meta: {
          title: '收益明细-对账结算',
          topNavName: '收益明细-对账结算',
          roleCode: AGRNT_AUTH_CODE.COMMISSION_INCOME,
          storePath: '/store/commission/incomepagemanual',
        },
        component: () => import('@/pages/commission/IncomePageManual.vue'),
      },
      {
        name: 'storeRecordList',
        path: '/agent/storeRecordList',
        meta: {
          title: '门店报表',
          topNavName: '门店报表',
          roleCode: AGRNT_AUTH_CODE.STORE_REPORT,
        },
        component: () =>
          import(
            /* webpackChunkName: "storeRecord" */ '../../pages/agent/StoreRecordList.vue'
          ),
      },
      {
        name: 'landBillStoreRecordList',
        path: '/agent/landBillStoreRecordList',
        meta: {
          title: '提货单',
          topNavName: '提货单',
          roleCode: AGRNT_AUTH_CODE.BILL_OF_LADING,
        },
        component: () =>
          import(
            /* webpackChunkName: "storeRecord" */ '../../pages/agent/StoreRecordList.vue'
          ),
      },
      {
        name: 'storeRecord',
        path: '/agent/storeRecord',
        meta: {
          title: '门店报表',
          topNavName: '门店报表',
          roleCode: AGRNT_AUTH_CODE.STORE_REPORT,
          storePath: '/store/storeRecord',
        },
        component: () =>
          import(
            /* webpackChunkName: "storeRecord" */ '../../pages/agent/StoreRecord.vue'
          ),
      },
      {
        name: 'columnPromotion',
        path: '/agent/columnPromotion',
        meta: {
          title: '栏目推广',
          topNavName: '栏目推广',
          roleCode: AGRNT_AUTH_CODE.COLUMN_PROMOTION,
        },
        component: () =>
          import(/* webpackChunkName: "period" */ '@/pages/agent/ColumnView'),
      },
      {
        name: 'waitDone',
        path: '/agent/waitDone',
        meta: {
          title: '待办任务',
          topNavName: '待办任务',
          roleCode: AGRNT_AUTH_CODE.TO_DO_TASKS,
        },
        component: () =>
          import(/* webpackChunkName: "period" */ '@/pages/agent/waitDone.vue'),
      },
      {
        name: 'myTeam',
        path: '/agent/myTeam',
        meta: {
          title: '我的团队',
          topNavName: '我的团队',
          storePath: '/store/storeTeam',
        },
        component: () =>
          import(/* webpackChunkName: "period" */ '@/pages/agent/MyTeam.vue'),
      },
      {
        name: 'Product',
        path: '/agent/product',
        meta: {
          title: '门店商品',
          topNavName: '门店商品',
          roleCode: AGRNT_AUTH_CODE.PRODUCT_PROMOTION,
        },
        component: () =>
          import(/* webpackChunkName: "period" */ '@/pages/agent/product.vue'),
      },
      {
        name: 'withoutAuth',
        path: '/agent/withoutAuth',
        meta: { title: '温馨提示', topNavName: '温馨提示' },
        component: () =>
          import(
            /* webpackChunkName: "withoutAuth" */ '@/pages/agent/withoutAuth.vue'
          ),
      },
      {
        name: 'jianKangWithoutAuth',
        path: '/agent/jianKangWithoutAuth',
        meta: { title: '温馨提示', topNavName: '温馨提示' },
        component: () =>
          import(
            /* webpackChunkName: "withoutAuth" */ '@/pages/agent/JianKangWithoutAuth.vue'
          ),
      },
      {
        name: 'socialRedEnvelope',
        path: '/agent/socialRedEnvelope',
        meta: {
          title: '社群红包',
          topNavName: '社群红包',
          roleCode: AGRNT_AUTH_CODE.COMMUNITY_RED_ENVELOPE,
        },
        component: () =>
          import(
            /* webpackChunkName: "SocialRedEnvelope" */ '@/pages/agent/SocialRedEnvelope'
          ),
      },
      {
        name: 'createRedEnvelope',
        path: '/agent/createRedEnvelope',
        meta: { title: '社群红包', topNavName: '社群红包' },
        component: () =>
          import(
            /* webpackChunkName: "SocialRedEnvelope" */ '@/pages/agent/SocialRedEnvelope/components/CreateRedEnvelope.vue'
          ),
      },
      {
        name: 'signStatistics',
        path: '/agent/signStatistics',
        meta: { title: '签到记录', topNavName: '签到记录' },
        component: () =>
          import(
            /* webpackChunkName: "signStatistics" */ '../../pages/agent/signStatistics.vue'
          ),
      },
      {
        name: 'groupSolitaire',
        path: '/agent/groupSolitaire',
        meta: { title: '群接龙列表', topNavName: '群接龙列表' },
        component: () =>
          import(
            /* webpackChunkName: "groupSolitaire" */ '../../pages/agent/groupSolitaire/index.vue'
          ),
      },
      {
        name: 'createGroupSolitaire',
        path: '/agent/createGroupSolitaire',
        meta: { title: '群接龙', topNavName: '群接龙' },
        component: () =>
          import(
            /* webpackChunkName: "groupSolitaire" */ '../../pages/agent/groupSolitaire/createGroupSolitaire.vue'
          ),
      },
      {
        name: 'groupSolitaireDetail',
        path: '/agent/groupSolitaireDetail',
        meta: { title: '群接龙详情', topNavName: '详情' },
        component: () =>
          import(
            /* webpackChunkName: "groupSolitaire" */ '../../pages/agent/groupSolitaire/groupSolitaireDetail.vue'
          ),
      },
      {
        name: 'dataCenter',
        path: '/agent/dataCenter',
        meta: { title: '数据', topNavName: '数据' },
        component: () =>
          import(
            /* webpackChunkName: "groupSolitaire" */ '../../pages/agent/groupSolitaire/dataCenter.vue'
          ),
      },
      {
        name: 'aliGuidePage',
        path: '/agent/aliGuidePage',
        meta: { whiteList: true, isNotShare: false },
        component: () => import('@/pages/agent/aliGuidePage.vue'),
      },
      {
        name: 'downloadPage',
        path: '/agent/download',
        meta: { whiteList: true, isNotShare: false },
        component: () => import('@/pages/agent/downloadPage.vue'),
      },
      {
        name: 'activateAgent',
        path: '/agent/activateAgent',
        meta: { title: '激活代理', topNavName: '激活代理' },
        component: () =>
          import(
            /* webpackChunkName: "withoutAuth" */ '@/pages/agent/activateAgent.vue'
          ),
      },
      {
        name: 'customerError',
        path: '/agent/customerError',
        meta: { title: '客服提示', topNavName: '客服提示' },
        component: () =>
          import(
            /* webpackChunkName: "SocialRedEnvelope" */ '@/pages/agent/CustomerError.vue'
          ),
      },
      {
        name: 'collectingCards',
        path: '/agent/collectCard',
        meta: {
          title: '集卡活动',
          roleCode: AGRNT_AUTH_CODE.COLLECTING_CARDS_FOR_REWARDS,
          storePath: '/store/collectCard',
        },
        component: () =>
          import(
            /* webpackChunkName: "collectCard" */ '@/pages/mine/collectCard.vue'
          ),
      },
      {
        name: 'consumptionList',
        path: '/agent/consumptionList',
        meta: {
          title: '消费榜',
          topNavName: '消费榜',
          roleCode: AGRNT_AUTH_CODE.CONSUMPTION_RANK,
          storePath: '/store/storeConsumptionList',
        },
        component: () =>
          import(
            /* webpackChunkName: "consumptionList" */ '../../pages/agent/consumptionList.vue'
          ),
      },
      {
        name: 'trafficStatistics',
        path: '/agent/trafficStatistics',
        meta: {
          title: '流量统计',
          topNavName: '流量统计',
          roleCode: AGRNT_AUTH_CODE.TRAFFIC_STATISTICS,
        },
        component: () =>
          import(
            /* webpackChunkName: "TrafficStatistics" */ '../../pages/agent/TrafficStatistics.vue'
          ),
      },
      {
        name: 'outstanding',
        path: '/agent/outstanding',
        meta: {
          title: '团队业绩',
          topNavName: '团队业绩',
          roleCode: AGRNT_AUTH_CODE.TEAM_PERFORMANCE,
        },
        component: () =>
          import(
            /* webpackChunkName: "outstanding" */ '../../pages/agent/outstanding/index.vue'
          ),
      },
      {
        name: 'payGift',
        path: '/agent/payGift',
        meta: {
          title: '支付有礼',
          topNavName: '支付有礼',
          roleCode: AGRNT_AUTH_CODE.PAY_WITH_GIFTS,
          storePath: '/store/payGift',
        },
        component: () =>
          import(
            /* webpackChunkName: "signStatistics" */ '../../pages/agent/PayGift/index.vue'
          ),
      },
      {
        name: 'activityRecords',
        path: '/agent/payGift/records',
        meta: {
          title: '支付有礼',
          topNavName: '支付有礼',
          storePath: '/store/payGift/records',
        },
        component: () =>
          import(
            /* webpackChunkName: "signStatistics" */ '../../pages/agent/PayGift/activityRecords.vue'
          ),
      },
      {
        name: 'SocialCommunityFission',
        path: '/agent/SocialCommunityFission',
        meta: {
          title: (to, from, isRetailFresh) =>
            isRetailFresh ? '推广团购' : '社群接龙',
          topNavName: (to, from, isRetailFresh) =>
            isRetailFresh ? '推广团购' : '社群接龙',
        },
        component: () =>
          import(
            /* webpackChunkName: "signStatistics" */ '../../pages/socialCommunityFission/index.vue'
          ),
      },
      {
        name: 'SocialCommunityFissionProduct',
        path: '/agent/SocialCommunityFissionProduct',
        meta: {
          title: (to, from, isRetailFresh) =>
            isRetailFresh ? '推广团购-活动详情' : '社群接龙-活动详情',
          topNavName: (to, from, isRetailFresh) =>
            isRetailFresh ? '推广团购-活动详情' : '社群接龙-活动详情',
          isNotShare: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "signStatistics" */ '../../pages/socialCommunityFission/SocialCommunityFissionProduct.vue'
          ),
      },
      {
        name: 'ScfProductDetails',
        path: '/agent/ScfProductDetails',
        meta: {
          title: (to, from, isRetailFresh) =>
            isRetailFresh ? '推广团购-商品详情' : '社群接龙-商品详情',
          topNavName: (to, from, isRetailFresh) =>
            isRetailFresh ? '推广团购-商品详情' : '社群接龙-商品详情',
        },
        component: () =>
          import(
            /* webpackChunkName: "signStatistics" */ '../../pages/socialCommunityFission/ScfProductDetails.vue'
          ),
        isNotShare: false,
      },
      {
        name: 'aliGuidePage',
        path: '/agent/aliGuidePage',
        meta: { whiteList: true, isNotShare: false },
        component: () => import('@/pages/agent/aliGuidePage.vue'),
      },
      {
        name: 'landBill',
        path: '/agent/landBill',
        meta: { title: '提货单', roleCode: AGRNT_AUTH_CODE.BILL_OF_LADING },
        component: () =>
          import(
            /* webpackChunkName: "userVerify" */ '@/pages/agent/landBill.vue'
          ),
      },
      {
        name: 'landBillDownloadCenter',
        path: '/agent/landBill/DownloadCenter',
        meta: { title: '下载中心', topNavName: '下载中心' },
        component: () =>
          import(
            /* webpackChunkName: "downloadCenter" */ '../../pages/agent/components/landBillDownloadCenter.vue'
          ),
      },
      {
        path: '/agent/403',
        name: '403',
        meta: { title: '403' },
        component: () =>
          import(/* webpackChunkName: "403" */ '../../pages/error/403.vue'),
      },
      {
        name: 'LuckyBagData',
        path: '/agent/luckyBagData',
        meta: { title: '福袋数据', topNavName: '福袋数据' },
        component: () =>
          import(
            /* webpackChunkName: "agentIndex" */ '../../pages/agent/luckyBagData'
          ),
      },
      {
        name: 'LuckyBagData',
        path: '/agent/luckyBagData',
        meta: { title: '福袋数据', topNavName: '福袋数据' },
        component: () =>
          import(
            /* webpackChunkName: "agentIndex" */ '../../pages/agent/luckyBagData'
          ),
      },
      {
        name: 'liveRoom',
        path: '/agent/liveRoom',
        meta: { title: '直播间列表', topNavName: '直播间列表' },
        component: () =>
          import(
            /* webpackChunkName: "agentIndex" */ '../../pages/agent/liveRoom'
          ),
      },
      {
        name: 'sendCoupons',
        path: '/agent/sendCoupons',
        meta: {
          title: '发优惠券',
          topNavName: '发优惠券',
          roleCode: AGRNT_AUTH_CODE.SEND_COUPONS,
        },
        component: () =>
          import(
            /* webpackChunkName: "SendCoupons" */ '../../pages/agent/SendCoupons/index.vue'
          ),
      },
      {
        name: 'performanceSatistics',
        path: '/agent/performanceSatistics',
        meta: {
          title: '业绩统计',
          topNavName: '业绩统计',
          roleCode: AGRNT_AUTH_CODE.TRANSACTION_PERFORMANCE_STATISTICS,
        },
        component: () =>
          import(
            /* webpackChunkName: "TrafficStatistics" */ '../../pages/agent/PerformanceSatistics.vue'
          ),
      },
      {
        name: 'WatchRewardList',
        path: '/agent/watchrewardlist',
        meta: { title: '观看奖励红包', topNavName: '观看奖励红包' },
        component: () =>
          import(
            /* webpackChunkName: "agentIndex" */ '../../pages/agent/agentWatchRewardList.vue'
          ),
      },
      {
        name: 'myBusinessCard',
        path: '/agent/myBusinessCard',
        meta: {
          title: '我的名片',
          topNavName: '我的名片',
          roleCode: AGRNT_AUTH_CODE.DRAINAGE_MY_BUSINESS_CARD,
        },
        component: () =>
          import(
            /* webpackChunkName: "MyBusinessCard" */ '../../pages/agent/myBusinessCard/index.vue'
          ),
      },
    ],
  },
  {
    name: 'AuthPage',
    path: '/agent/authPage',
    meta: { whiteList: true, isNotShare: false },
    component: () =>
      import(/* webpackChunkName: "authPage" */ '@/pages/agent/authPage.vue'),
  },
  {
    name: 'openAccount',
    path: '/agent/openAccount',
    meta: {},
    component: () =>
      import(
        /* webpackChunkName: "openAccount" */ '@/pages/agent/openAccount.vue'
      ),
  },
  {
    name: 'YBOpenAccount',
    path: '/agent/YeeOpenAccount',
    meta: {},
    component: () =>
      import(
        /* webpackChunkName: "YeeOpenAccount" */ '@/pages/agent/YeeOpenAccount/YeeOpenAccount.vue'
      ),
  },
  {
    name: 'openAccountStatus',
    path: '/agent/openAccountStatus',
    meta: {},
    component: () =>
      import(
        /* webpackChunkName: "openAccountStatus" */ '@/pages/agent/openAccountStatus.vue'
      ),
  },
  {
    name: 'openAccountStatus',
    path: '/agent/YeeOpenAccountStatus',
    meta: {},
    component: () =>
      import(
        /* webpackChunkName: "YeeOpenAccountStatus" */ '@/pages/agent/YeeOpenAccount/YeeOpenAccountStatus.vue'
      ),
  },
  {
    name: 'periodInviteCard',
    path: '/agent/periodInviteCard',
    meta: { title: '档期海报', topNavName: '档期海报' },
    component: () =>
      import(
        /* webpackChunkName: "newInviteCard" */ '../../pages/agent/periodInviteCard.vue'
      ),
  },
  {
    name: 'integralMall',
    path: '/agent/integralMall',
    meta: { title: '积分商城', topNavName: '积分商城' },
    component: () =>
      import(
        /* webpackChunkName: "integralMall" */ '../../pages/agent/integralMall.vue'
      ),
  },
  {
    name: 'deliveryCode',
    path: '/agent/deliveryCode',
    meta: { title: '提货码' },
    component: () =>
      import(
        /* webpackChunkName: "DeliveryCode" */
        '../../pages/agent/ScanCode/DeliveryCode.vue'
      ),
  },
  {
    name: 'viewTimeCode',
    path: '/agent/viewTimeCode',
    meta: { title: '时长码' },
    component: () =>
      import(
        /* webpackChunkName: "ViewTimeCode" */
        '../../pages/agent/ScanCode/ViewTimeCode.vue'
      ),
  },
  {
    name: 'couponCode',
    path: '/agent/couponCode',
    meta: { title: '优惠券码' },
    component: () =>
      import(
        /* webpackChunkName: "CouponCode" */
        '../../pages/agent/ScanCode/CouponCode.vue'
      ),
  },
  {
    name: 'pointCode',
    path: '/agent/pointCode',
    meta: { title: '积分码' },
    component: () =>
      import(
        /* webpackChunkName: "PointCode" */
        '../../pages/agent/ScanCode/PointCode.vue'
      ),
  },
  {
    name: 'agentBind',
    path: '/agent/agentBind',
    meta: { title: '绑定代理', topNavName: '绑定代理', whiteList: true },
    component: () =>
      import(
        /* webpackChunkName: "agentBind" */ '../../pages/agent/agentBind.vue'
      ),
  },
  {
    name: 'MsgSet',
    path: '/agent/msgSet',
    meta: {
      title: '消息设置',
      topNavName: '消息设置',
      // roleCode: AGRNT_AUTH_CODE.MSG_SETTING,
    },
    component: () =>
      import(
        /* webpackChunkName: "agentBind" */ '../../pages/agent/msgSet.vue'
      ),
  },
  ...erpRouter,
]

agentRouterList[0].children.forEach(item => {
  if (
    [
      'agentIndex',
      'aliGuidePage',
      'SocialCommunityFissionProduct',
      'ScfProductDetails',
    ].includes(item.name)
  ) {
    item.meta.isNotShare = false
  } else {
    item.meta.isNotShare = true
  }
  item.meta.type = 'agent'
})
export default agentRouterList
